module.exports = __webpack_public_path__ + "static/media/PROTOCOLO DE ATENCIÓN A PERSONAS CON CAPACIDAD REDUCIDA 31-05-2024.d57d2cf5.pdf";